import { ActionReducer } from '@ngrx/store';
import { ActionTypes, Actions } from './cabinets.actions';
import { CabinetsInterface as Cabinets } from './cabinets.models';
import { tassign } from '../../tools';

/**
 * Please do not modify the store directly. Always use reducers.
 */

export const initialCabinetsState: Cabinets = {
	items: [],
	isLoading: false
};

/**
 * Reduce the store.
 * @param {Cabinets} state - the current state
 * @return {Cabinets} The new state
 */
export const cabinets: ActionReducer<any, Actions> = (state: Cabinets = initialCabinetsState, action: Actions): Cabinets => {
	switch (action.type) {

		case ActionTypes.LOAD_CABINETS:
			return action.payload;

		case ActionTypes.RESET_STATE:
			return initialCabinetsState;

		case ActionTypes.SET_IS_LOADING:
			return tassign(state, {
				isLoading: action.payload
			});
	}
	return state;
};